import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');

// NOTE: we deliberately client-render (createRoot) rather than hydrateRoot, even when
// react-snap has pre-rendered the page. This app styles everything with inline style
// objects, which react-snap's headless browser re-serializes when it captures the HTML
// (e.g. `background:#fff` -> `background: white`, `top:0` -> `top: 0px`). React 18
// treats that as a hydration mismatch (#418/#423) and, on this app, fails to attach
// event handlers to some elements — so buttons/dropdowns silently stop working.
// A clean createRoot render attaches all handlers correctly. The pre-rendered HTML is
// still served to crawlers and shows on first paint; React then renders the identical
// (snapshot-seeded) content over it, so there's no content flash.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode><App /></React.StrictMode>
);
